import { Organizador } from '../services/torneioService';

/**
 * Verifica se um usuário é organizador de um torneio
 * @param torneio - Objeto do torneio com array de organizadores
 * @param userId - ID do usuário a verificar
 * @returns true se o usuário é organizador, false caso contrário
 */
export function isOrganizadorTorneio(
  torneio: { organizadores?: Organizador[] | null } | null | undefined,
  userId: string | null | undefined
): boolean {
  if (!torneio || !userId) {
    return false;
  }

  if (!torneio.organizadores || torneio.organizadores.length === 0) {
    return false;
  }

  return torneio.organizadores.some(
    (org) => org.usuario?.id === userId
  );
}

/**
 * Verifica se um usuário tem permissão para gerenciar inscrições de um torneio
 * (é ADMIN ou organizador do torneio)
 * @param torneio - Objeto do torneio com array de organizadores
 * @param userId - ID do usuário a verificar
 * @param userRole - Role do usuário (ex: 'ADMIN', 'ATLETA')
 * @returns true se o usuário tem permissão, false caso contrário
 */
export function canManageInscricoes(
  torneio: { organizadores?: Organizador[] | null } | null | undefined,
  userId: string | null | undefined,
  userRole: string | null | undefined
): boolean {
  if (userRole === 'ADMIN') {
    return true;
  }

  return isOrganizadorTorneio(torneio, userId);
}

